module.exports = __webpack_public_path__ + "img/jujue_512x512.a3d11358.png";